exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".IA_OrgAssetContainer_2qqdr1Cbs6TDtGxag4Y3Wo {\n  display: flex;\n  flex-direction: column;\n  padding-left: 40px;\n  padding-right: 40px;\n}\n\n.IA_OrgAssetItemsContainer_1_UsnWRqvQ2PW_0odYH6tP {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n}\n\n.IA_OrgAssetErrorMessage_3WEpcz3jdb7p7SvAdbrxpK {\n  padding-top: 15px;\n  font-size: 16px;\n}", ""]);

// Exports
exports.locals = {
	"IA_OrgAssetContainer": "IA_OrgAssetContainer_2qqdr1Cbs6TDtGxag4Y3Wo",
	"IA_OrgAssetItemsContainer": "IA_OrgAssetItemsContainer_1_UsnWRqvQ2PW_0odYH6tP",
	"IA_OrgAssetErrorMessage": "IA_OrgAssetErrorMessage_3WEpcz3jdb7p7SvAdbrxpK"
};